import React from 'react';
import graph from './graph';

import { UserModel } from 'models';
import { toast } from 'react-toastify';
import { Button } from '@mui/material';
import { useSelector } from 'react-redux';
import { useMutation } from '@apollo/client';
import { isEmptyObject } from 'helpers/formatObject';

export default function AssignSelectedUser({ id, active, refetch, shop, users }) {
  const { userToken } = useSelector((state) => state.auth);

  const [assignment, { loading }] = useMutation(graph.assignment.query, {
    context: {
      serviceName: graph.assignment.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const onAssign = async (selected, onClose) => {
    try {
      const { data, errors } = await assignment({
        variables: {
          coupon_id: id,
          send_sms: ['FOR_SET_COUPON'],
          user_ids: selected.map((item) => item.id),
        },
      });
      if (!errors) {
        refetch();
        onClose();
        if (!isEmptyObject(data)) {
          data[graph.assignment.name]?.messages.map((message) => toast.success(String(message)));
        }
      }
    } catch (error) {}
  };

  return (
    <>
      <UserModel
        isPopup
        isAssign
        multiSelect
        title="اختصاص کاربر"
        disabled={loading}
        onAssign={onAssign}
        assigning={loading}
        initFilter={{ shop_ids: shop }}
        preSelected={users.map((item) => ({ id: item.id, title: item.username }))}
        action={
          <Button
            fullWidth
            size="medium"
            color="info"
            variant={active ? 'contained' : 'text'}
            sx={{ bgcolor: !active && 'info.lighter', color: 'info.dark' }}
          >
            اختصاص کاربر
          </Button>
        }
      />
    </>
  );
}
